import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  getElementsById,
  getElementsEventDataById,
} from "core-integration/src/store/elements/reducers";
import { fetchEventLive } from "core-integration/src/store/elements/thunks";
import {
  getEntry,
  getEntryEventFormation,
  getEntryEventPicks,
  getEntryEventPoints,
} from "core-integration/src/store/entries/reducers";
import {
  fetchEntryEventPicks,
  fetchEntrySummary,
} from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import {
  getLastEvent,
  getCurrentEvent,
  getEventsById,
} from "core-integration/src/store/events/reducers";
import { getFixturesForEventById } from "core-integration/src/store/fixtures/reducers";
import { fetchFixtures } from "core-integration/src/store/fixtures/thunks";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { IPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import range from "lodash/range";
import { hideVisually, size } from "polished";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router";
import styled, { css } from "styled-components";
import BaseDreamTeam from "../../img/icons/dreamteam.svg?react";
import BaseReload from "../../img/icons/reload.svg?react";
import { ChipName, getChipName } from "../../utils/chips";
import Box from "../Box";
import ButtonLink from "../ButtonLink";
import Entry from "../Entry";
import Fixtures from "../Fixtures";
import { ArrowLeft, ArrowRight, ControlArrowRight } from "../icons/Arrows";
import DreamTeam from "../icons/DreamTeam";
import { Main, Secondary, Wrapper } from "../Layout";
import PageAd from "../PageAd";
import {
  EventPager,
  PagerButton,
  PagerButtonNext,
  PagerHeading,
} from "../Pager";
import Panel from "../Panel";
import { ElementRow } from "../Pitch";
import { NotFound } from "../Routes";
import Table from "../Table";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import Title from "../Title";
import Bench from "./Bench";
import BenchUnit from "./BenchUnit";
import ElementExplainDialog from "./ElementExplainDialog";
import EntryEventTable from "./EntryEventTable";
import PitchFormation from "./PitchFormation";
import valueForPlayerElement from "./valueForPlayedElement";

const EntryEventTableWrap = styled.div`
  margin: ${({ theme }) => theme.space[4]} 0;
  background-color: white;
`;

const PointsScoreboardWrap = styled.div`
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.secondary};
  margin: ${({ theme }) => theme.space[2]} 0;
  padding: ${({ theme }) =>
    `${theme.space[3]} ${theme.space[1]} ${theme.space[1]}`};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
  }
`;

const StyledPitchWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space[5]};
  padding-top: ${({ theme }) => theme.space[4]};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
  }
`;

const PointsScoreboard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: ${({ theme }) => theme.space[2]} 0;
  margin: 0 ${({ theme }) => theme.space[2]};
`;

const ScoreboardPrimary = styled.div`
  flex: 0 0 38%;
  padding-inline-end: ${({ theme }) => theme.space[2]};
  padding-inline-start: ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 0 0 34%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex-basis: calc(22% - ${({ theme }) => theme.space[1]});
    margin-bottom: 0;
  }
`;

interface IPrimaryPanelProps {
  chipPlayed?: boolean;
}

const PrimaryPanel = styled.div<IPrimaryPanelProps>`
  position: relative;
  border-radius: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;

  ${(props) =>
    props.chipPlayed &&
    css`
      padding-top: 2rem;
      padding-bottom: 1.8rem;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-bottom: 0;
  }
`;

const PrimaryHeading = styled.h4`
  margin: 0;
  padding: 1.5rem;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: bold;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-top: 0.8rem;
    padding-bottom: 0.7rem;
  }
`;

const PrimaryValue = styled.div`
  padding-top: ${({ theme }) => theme.space[3]};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 4rem;
  font-weight: bold;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: 4rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-bottom: 0.3rem;
  }
`;

const ReloadButton = styled.button`
  position: absolute;
  top: 40%;
  inset-inline-start: 0;
  transform: translateY(-50%) scaleX(1);
  padding: ${({ theme }) => theme.space[1]};
  border: 0;
  border-radius: ${({ theme }) => theme.radii[0]};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};
  line-height: 0;
  cursor: pointer;
`;

const Reload = styled(BaseReload)`
  fill: ${({ theme }) => theme.colors.primary};
`;

const ReloadButtonText = styled.span`
  ${hideVisually()}
`;

const ScoreboardSecondary = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const SecondaryPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

const SecondaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  border: ${({ theme }) => theme.borders[6]};
  border-radius: ${({ theme }) => theme.radii[2]};
  background-color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex-basis: 45%;
    margin: 0;
  }
`;

const SecondaryHeading = styled.h4`
  margin: ${({ theme }) => theme.space[2]};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: normal;
`;

const SecondaryValue = styled.div`
  padding-bottom: 0.7rem;
  font-size: ${({ theme }) => theme.fontSizes[5]};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    font-size: ${({ theme }) => theme.fontSizes[6]};
  }
`;

const DreamTeamWrap = styled.div`
  width: 40%;
  margin: 0 auto ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 25%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 30%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 20%;
  }
`;

const DreamTeamLinkIcon = styled(BaseDreamTeam)`
  ${size(16)}
  margin-inline-end: ${({ theme }) => theme.space[1]};
`;

const DreamTeamLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: ${({ theme }) => theme.radii[1]};
  padding: 0.6rem;
  background-color: ${({ theme }) => theme.colors.accentRed};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
`;

const ChipStatus = styled.div`
  padding: ${({ theme }) => theme.space[2]};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.1rem;
  font-weight: bold;
  text-align: center;
`;

type Props = WithTranslation;

const EntryEvent: React.FC<Props> = ({ t }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const [pickForMenu, setPickForMenu] = useState<IPickLight | null>(null);
  const params = useParams();
  const entryId = Number(params.entryId);
  const eventId = Number(params.eventId);
  const player = useSelector(getPlayerData) as IPlayer;
  const elementsById = useSelector(getElementsById);
  const elementsDataById = useSelector((state: RootState) =>
    getElementsEventDataById(state, eventId),
  );
  const entry = useSelector((state: RootState) => getEntry(state, entryId));
  const entryData = useSelector((state: RootState) =>
    getEntryEventPicks(state, entryId, eventId),
  );
  const event = useSelector(
    (state: RootState) => getEventsById(state)[eventId],
  );
  const fixturesById = useSelector((state: RootState) =>
    getFixturesForEventById(state, eventId),
  );
  const formation = useSelector((state: RootState) =>
    getEntryEventFormation(state, entryId, eventId),
  );
  const lastEvent = useSelector(getLastEvent);
  const mine = Boolean(player && player.entry && player.entry === entryId);
  const now = useSelector((state: RootState) => getCurrentEvent(state));
  const points = useSelector((state: RootState) =>
    getEntryEventPoints(state, entryId, eventId),
  );
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);

  const handleShowMenuForPickElement = (element: number) => {
    const matches = entryData!.picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsDataById &&
    elementsDataById[pick.element] &&
    elementsDataById[pick.element].stats.in_dreamteam ? (
      <Link to={`/dream-team/${event!.id}`}>
        <DreamTeam />
      </Link>
    ) : null;

  const fetchDataAndFixtures = () => {
    fetchData();
    dispatch(fetchFixtures(eventId));
  };

  const fetchData = useCallback(() => {
    dispatch(fetchEntrySummary(entryId));
    dispatch(fetchEntryEventPicks(entryId, eventId));
    dispatch(fetchEventLive(eventId));
  }, [dispatch, entryId, eventId]);

  useEffect(() => {
    fetchData();
  }, [entryId, eventId, fetchData]);

  // Handle unknown and unstarted events
  if (!now || !event || event.id > now.id) {
    return <NotFound />;
  }
  if (!entry || !entryData) {
    return null;
  }

  const chipName = entryData.active_chip
    ? getChipName(entryData.active_chip as ChipName, t)
    : "";

  // Create a new function on each render as data could have changed and
  // need to ensure a render of connected subcomponents
  const renderPickValue = valueForPlayerElement({
    elementsById,
    elementsDataById,
    fixturesById,
    teamsById,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    11: (
      <abbr title={t<string>("entryEvent.goalkeeper.title", "Goalkeeper")}>
        {t("entryEvent.goalkeeper.abbr", "GK")}
      </abbr>
    ),
    12: "1",
    13: "2",
    14: "3",
  };

  // Handle events before the entry started
  return (
    <Wrapper>
      <Main>
        <Box mx={2} mb={4}>
          <Title>
            {t("entryEvent.title", "Points")} - {entry.name}
          </Title>
        </Box>
        <PageAd />

        {/* ROUND PAGER */}
        <PointsScoreboardWrap>
          <Box>
            {(event.id > entry.started_event || event.id < now.id) && (
              <EventPager>
                {event.id > entry.started_event && (
                  <PagerButton>
                    <ButtonLink
                      to={`/entry/${entry.id}/event/${event.id - 1}`}
                      variant="secondary"
                      justifyContent="flexStart"
                    >
                      <ArrowLeft />
                      {t("entryEvent.prev", "Previous")}
                    </ButtonLink>
                  </PagerButton>
                )}
                {event.id <= entry.started_event && <PagerButton />}
                <Box mx={2}>
                  <PagerHeading>{event.name}</PagerHeading>
                </Box>
                {event.id < now.id && (
                  <PagerButtonNext>
                    <ButtonLink
                      to={`/entry/${entry.id}/event/${event.id + 1}`}
                      variant="secondary"
                      justifyContent="flexEnd"
                    >
                      {t("entryEvent.next", "Next")}
                      <ArrowRight />
                    </ButtonLink>
                  </PagerButtonNext>
                )}
                {/* Also need to check isn't last event */}
                {mine &&
                  event.id === now.id &&
                  lastEvent &&
                  event.id !== lastEvent.id && (
                    <PagerButtonNext>
                      <ButtonLink
                        to={`/my-team`}
                        variant="secondary"
                        justifyContent="flexEnd"
                      >
                        {t("entryEvent.next", "Next")}
                        <ArrowRight />
                      </ButtonLink>
                    </PagerButtonNext>
                  )}
                {event.id >= now.id &&
                  (!mine || !lastEvent || event.id === lastEvent.id) && (
                    <PagerButtonNext />
                  )}
              </EventPager>
            )}
          </Box>

          {/* SCOREBOARD */}

          <Box>
            <PointsScoreboard>
              <ScoreboardSecondary>
                <SecondaryPanel>
                  <SecondaryItem>
                    <SecondaryHeading>
                      {t("entryEvent.average", "Average Pts")}
                    </SecondaryHeading>
                    <SecondaryValue>
                      {event.average_entry_score || "-"}
                    </SecondaryValue>
                  </SecondaryItem>
                  <SecondaryItem>
                    <SecondaryHeading>
                      {t("entryEvent.highest", "Highest Pts")}
                    </SecondaryHeading>
                    <SecondaryValue>
                      {event.highest_scoring_entry ? (
                        <Link
                          to={`/entry/${event.highest_scoring_entry}/event/${event.id}`}
                        >
                          {event.highest_score || "???"}
                        </Link>
                      ) : (
                        "-"
                      )}
                    </SecondaryValue>
                  </SecondaryItem>
                </SecondaryPanel>
                <ScoreboardPrimary>
                  <Box>
                    <PrimaryPanel chipPlayed={Boolean(chipName)}>
                      <PrimaryValue>
                        {points}
                        {!event.finished && (
                          <ReloadButton onClick={fetchDataAndFixtures}>
                            <ReloadButtonText>
                              {t("entryEvent.reload", "Reload Points")}
                            </ReloadButtonText>
                            <Reload />
                          </ReloadButton>
                        )}
                      </PrimaryValue>
                      <PrimaryHeading>
                        {event.finished
                          ? t("entryEvent.finalPoints", "Final Points")
                          : t("entryEvent.latestPoints", "Latest Points")}
                      </PrimaryHeading>
                      {chipName && (
                        <ChipStatus>
                          {t(
                            "entryEvent.ChipStatus.played",
                            "{{ chipName }} played",
                            {
                              chipName: chipName,
                            },
                          )}
                        </ChipStatus>
                      )}
                    </PrimaryPanel>
                  </Box>
                </ScoreboardPrimary>
                <SecondaryPanel>
                  <SecondaryItem>
                    <SecondaryHeading>
                      {t("entryEvent.rank", "RD Rank")}
                    </SecondaryHeading>
                    <SecondaryValue>
                      {entryData.entry_history.rank
                        ? entryData.entry_history.rank.toLocaleString()
                        : "-"}
                    </SecondaryValue>
                  </SecondaryItem>
                  <SecondaryItem>
                    <SecondaryHeading>
                      {t("entryEvent.transfers", "Transfers")}
                    </SecondaryHeading>
                    <SecondaryValue>
                      <Link to={`/entry/${entry.id}/transfers`}>
                        {entryData.entry_history.event_transfers}
                      </Link>{" "}
                      {entryData.entry_history.event_transfers_cost
                        ? `(-${entryData.entry_history.event_transfers_cost} pts)`
                        : ""}
                    </SecondaryValue>
                  </SecondaryItem>
                </SecondaryPanel>
              </ScoreboardSecondary>
            </PointsScoreboard>
            <DreamTeamWrap>
              <DreamTeamLink to={`/dream-team/${event.id}`}>
                <DreamTeamLinkIcon />
                {t("entryEvent.dreamTeam", "Dream Team")}
                <ControlArrowRight />
              </DreamTeamLink>
            </DreamTeamWrap>
          </Box>
        </PointsScoreboardWrap>

        {/* TEAM */}
        <StyledPitchWrapper>
          <Tabs centered>
            <TabPanel
              label={t("entryEvent.pitchView", "Pitch View")}
              link="pitch"
            >
              <Box mx={-2} pt={4}>
                <PitchFormation
                  chipName={entryData.active_chip}
                  formation={formation}
                  picks={entryData.picks}
                  renderDreamTeam={renderDreamTeam}
                  renderElementMenu={handleShowMenuForPickElement}
                  renderPickValue={renderPickValue}
                />
                <Bench>
                  <ElementRow>
                    {range(rules.squad_squadplay, rules.squad_squadsize).map(
                      (i) => (
                        <BenchUnit
                          key={i}
                          chipName={entryData.active_chip}
                          heading={benchHeading[i]}
                          pick={entryData.picks[i]}
                          renderDreamTeam={renderDreamTeam}
                          renderElementMenu={() =>
                            handleShowMenuForPickElement(
                              entryData.picks[i].element,
                            )
                          }
                          renderPickValue={renderPickValue}
                        />
                      ),
                    )}
                  </ElementRow>
                </Bench>
              </Box>
            </TabPanel>
            <TabPanel label={t("entryEvent.listView", "List View")} link="list">
              <EntryEventTableWrap>
                <EntryEventTable
                  title={t("entryEvent.starters", "Starters")}
                  picks={entryData.picks.slice(0, rules.squad_squadplay)}
                  renderElementMenu={handleShowMenuForPickElement}
                  chipName={entryData.active_chip}
                  dataById={elementsDataById}
                />
                <EntryEventTable
                  title={t("entryEvent.substitutes", "Substitutes")}
                  picks={entryData.picks.slice(rules.squad_squadplay)}
                  renderElementMenu={handleShowMenuForPickElement}
                  chipName={entryData.active_chip}
                  dataById={elementsDataById}
                />
              </EntryEventTableWrap>
            </TabPanel>
          </Tabs>
        </StyledPitchWrapper>
        {entryData.automatic_subs.length > 0 && (
          <Box my={4}>
            <Panel>
              <Panel.Header
                title={t(
                  "entryEvent.autoSubs.title",
                  "Automatic Substitutions",
                )}
              ></Panel.Header>

              <Table>
                <thead>
                  <tr>
                    <th>{t("entryEvent.autoSubs.playerOut", "Player out")}</th>
                    <th>{t("entryEvent.autoSubs.playerIn", "Player in")}</th>
                  </tr>
                </thead>
                <tbody>
                  {entryData.automatic_subs.map((s) => (
                    <tr key={s.element_out}>
                      <td>{elementsById[s.element_out].web_name}</td>
                      <td>{elementsById[s.element_in].web_name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Panel>
          </Box>
        )}
        {pickForMenu && (
          <ElementExplainDialog
            elementId={pickForMenu.element}
            eventId={event.id}
            closeDialog={handleHideMenuForPick}
          />
        )}
        <Fixtures eventId={event.id} />
      </Main>
      <Secondary>
        <Entry entryId={entry.id} />
      </Secondary>
    </Wrapper>
  );
};

export default withTranslation()(EntryEvent);
